import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter8_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was ist das Hauptziel der DORA-Verordnung?",
      options: [
        {
          value: "A",
          label:
            "Die Einführung einer einheitlichen Währung für digitale Finanztransaktionen in der EU.",
        },
        {
          value: "B",
          label:
            "Die Stärkung der digitalen Resilienz von Finanzinstituten gegenüber Cyberbedrohungen.",
        },
      ],
      correct: "B",
    },
    {
      question:
        "Frage 2: Welche Meldefrist schreibt DORA für sicherheitsrelevante IT-Vorfälle in der Regel vor?",
      options: [
        {
          value: "A",
          label: "Innerhalb von 24 Stunden nach Entdeckung des Vorfalls.",
        },
        {
          value: "B",
          label: "Innerhalb von 7 Tagen nach Behebung des Vorfalls.",
        },
      ],
      correct: "A",
    },
  ];

 
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 8_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "8_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("8_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 8_3.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "8_3",
              completedChapters: ["8_3"],
            });
          console.log("Dokument erstellt mit Kapitel 8_3");
        }

        navigate("/cybersecurity/8_4"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  8: Regulatorische Anforderungen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                DORA
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 8: Regulatorische Anforderungen
          </h3>

          <img
            src="/images/dora.png"
            alt="DORA"
            style={{ position: "relative", maxWidth: "18%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Was ist DORA? </h2>
          <p className="col-lg-11 mx-auto">
            DORA (Digital Operational Resilience Act) ist eine
            EU-weite gesetzliche Regelung, mit der die digitale Widerstandsfähigkeit
            von Finanzinstituten gestärkt werden soll. Mit der Verordnung reagiert die
            Europäische Union auf die zunehmenden Cyberbedrohungen, die den
            Finanzsektor in seiner Funktion als zentrale Stütze der Wirtschaft
            betreffen. DORA schafft erstmals einheitliche Standards zur
            Cybersecurity und Informationssicherheit, die für alle
            Mitgliedstaaten verbindlich sind.
            <br />
            <br />
            Obwohl DORA und die NIS2-Richtlinie beide die Erhöhung derCybersecurity zum Ziel
            haben, gibt es Unterschiede:
            <br />
            <br />
            NIS2 deckt mehrere kritische Sektoren ab, darunter Energie,
            Gesundheitswesen und Transport, mit einem breiteren Fokus auf die
            allgemeine Cybersecurity.
            <br />
            <br />
            DORA konzentriert sich auf den Finanzsektor und umfasst spezifische
            Anforderungen an die Resilienz von Finanzunternehmen und deren
            IT-Dienstleistern.
          </p>
          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            DORA betrifft schätzungsweise 22.000 Unternehmen in der EU, darunter
            Banken, Versicherungen, Zahlungsdienstleister, Crypto-Anbieter und
            IT-Dienstleister, die mit Finanzunternehmen zusammenarbeiten.
          </p>

          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h2 className="col-lg-11 p-5 text-center mx-auto">
                  Ziele der DORA-Verordnung
                </h2>

                <p className="col-lg-11 text-center mx-auto">
                  Die Verordnung verfolgt mehrere wichtige Ziele:
                  <br />
                  <br />
                  <strong>Verbesserung der digitalen Resilienz: </strong>
                  Finanzunternehmen müssen in der Lage sein, auch unter widrigen
                  Bedingungen wie Cyberangriffen, IT-Ausfällen oder
                  Naturkatastrophen ihre Dienstleistungen sicherzustellen.
                  <br />
                  <br />
                  <strong>Einheitliche Standards: </strong>
                  Durch einheitliche Vorschriften innerhalb der EU soll die
                  Fragmentierung nationaler Regelungen beseitigt werden. Dies
                  erleichtert die grenzüberschreitende Zusammenarbeit und sorgt
                  für mehr Klarheit bei der Einhaltung von Vorschriften.
                  <br />
                  <br />
                  <strong>Schutz des Finanzsystems: </strong>
                  Die Widerstandsfähigkeit einzelner Finanzakteure stärkt das
                  gesamte Finanzsystem und erhöht das Vertrauen von Verbrauchern
                  und Investoren.
                  <br />
                  <br />
                  <strong>Stärkung der Aufsicht: </strong>
                  Durch DORA erhalten Aufsichtsbehörden in den Mitgliedstaaten
                  neue Instrumente, um die Einhaltung der Vorschriften zu
                  überprüfen und durchzusetzen.
                </p>
              </div>
            </div>
          </div>

          <div className="white-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">
                  Zentrale Anforderungen des DORA
                </h3>
                <p className="col-lg-11 mx-auto">
                  Die Verordnung schreibt eine Reihe von Maßnahmen vor, die
                  Finanzunternehmen umsetzen müssen:
                  <br />
                  <br />
                  <section class="p-5 text-start">
                    <ul class="timeline">
                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">1. Risikomanagement:</h5>

                        <p>
                          Unternehmen müssen Prozesse zur Identifikation,
                          Bewertung und Steuerung von IT-Risiken einrichten.
                          Dies umfasst die Analyse potenzieller Bedrohungen und
                          die Umsetzung technischer Schutzmaßnahmen.
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">2. Resilienztests:</h5>

                        <p>
                          Regelmäßige Tests der digitalen Resilienz, wie
                          Penetrationstests und Simulationen von IT-Ausfällen,
                          sind verpflichtend. Diese Tests sollen sicherstellen,
                          dass Unternehmen auch unter extremen Bedingungen
                          funktionsfähig bleiben.
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">3. Meldepflichten:</h5>

                        <p>
                          Sicherheitsvorfälle, die den Betrieb beeinträchtigen
                          oder sensible Daten gefährden, müssen umgehend an die
                          zuständigen Aufsichtsbehörden gemeldet werden. Die
                          Meldung muss innerhalb von 24 Stunden erfolgen, ein
                          detaillierter Bericht innerhalb von 72 Stunden.
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">4. Lieferkettenmanagement:</h5>

                        <p>
                          Finanzunternehmen müssen sicherstellen, dass auch
                          externe IT-Dienstleister die erforderlichen
                          Sicherheitsstandards einhalten. Dies schließt Audits
                          und Risikoanalysen für Drittanbieter ein.
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">
                          5. Krisenmanagement und Wiederherstellungspläne:
                        </h5>

                        <p>
                          Unternehmen sind verpflichtet, Notfallpläne zu
                          entwickeln, die den Betrieb im Falle eines Ausfalls
                          schnell wiederherstellen können. Diese Pläne müssen
                          regelmäßig aktualisiert und getestet werden.
                        </p>
                      </li>
                    </ul>
                  </section>
                </p>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Laut EU-Schätzungen werden Unternehmen über einen Zeitraum von
                  10 Jahren rund 2 Milliarden Euro in die Umsetzung der
                  DORA-Anforderungen investieren müssen. Die größten Ausgaben
                  betreffen Stresstests, Meldeinfrastruktur und die Überwachung
                  von Drittanbietern.{" "}
                </p>
              </div>
            </div>
          </div>

          <div className="gelb-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">
                  Risikomanagement und Abhängigkeit von Drittanbietern
                </h3>
                <p className="col-lg-11 mx-auto">
                  Die DORA-Verordnung legt großen Wert auf ein umfassendes{" "}
                  <strong>Risikomanagement, </strong> insbesondere im Umgang mit{" "}
                  <strong>Drittanbietern. </strong> Finanzinstitute, die eng mit
                  externen IT-Dienstleistern arbeiten, müssen Risiken entlang
                  der Lieferkette systematisch identifizieren, bewerten und
                  kontrollieren. Ziel ist es, Schwachstellen frühzeitig zu
                  erkennen und Sicherheitsvorgaben konsequent durchzusetzen.
                  <br />
                  <br />
                  Finanzinstitute sind verpflichtet, die Risiken durch
                  Drittanbieter nach ihrer potenziellen Auswirkung auf die
                  Geschäftskontinuität zu <strong> bewerten. </strong>{" "}
                  Wesentliche Dienstleister, die kritische Funktionen
                  bereitstellen, erfordern besonders sorgfältige Überwachung und
                  regelmäßige Sicherheitsprüfungen. Dabei müssen Drittanbieter
                  dieselben hohen Standards wie die Finanzinstitute selbst
                  einhalten. Dazu gehören Maßnahmen wie Verschlüsselung,
                  Zugangskontrollen und klare Vorgaben zur Datensicherheit.
                  <br />
                  <br />
                  DORA fordert{" "}
                  <strong>detaillierte Verträge mit Drittanbietern,</strong> die
                  Sicherheits- und Resilienzanforderungen sowie
                  Service-Level-Agreements (SLAs) enthalten. Diese legen unter
                  anderem fest, wie Vorfälle gemeldet werden und welche
                  Maßnahmen zur Wiederherstellung im Krisenfall erforderlich
                  sind. <strong>Regelmäßige Audits </strong> sollen
                  sicherstellen, dass die vereinbarten Standards eingehalten
                  werden. Die Ergebnisse dieser Überprüfungen müssen
                  dokumentiert und können bei Bedarf mit Aufsichtsbehörden
                  geteilt werden.
                  <br />
                  <br />
                  <strong>
                    Notfallpläne und Krisenmanagement für Abhängigkeiten von
                    Drittanbietern{" "}
                  </strong>{" "}
                  sind ein weiterer zentraler Bestandteil. Sie sollen
                  sicherstellen, dass bei Störungen durch Drittanbieter der
                  Betrieb schnell wiederhergestellt werden kann. Diese Pläne
                  definieren klare Verantwortlichkeiten und koordinierte
                  Reaktionsmaßnahmen, um die Auswirkungen auf die Lieferkette zu
                  minimieren. Durch diese umfassenden Vorgaben stärkt DORA die
                  Widerstandsfähigkeit von Finanzinstituten gegenüber Risiken in
                  der Zusammenarbeit mit Drittanbietern.
                </p>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Über 60% der Finanzunternehmen in der EU nutzen Cloud-Dienste
                  für kritische Geschäftsprozesse. DORA nimmt diese Unternehmen
                  besonders in die Pflicht, da sie potenzielle Schwachstellen in
                  der Lieferkette darstellen. Laut ENISA (Agentur der EU für
                  Cybersecurity) hat sich die Anzahl von Sicherheitsvorfällen,
                  die auf Drittanbieter zurückzuführen sind, seit 2018
                  verdoppelt.
                </p>
              </div>
            </div>
          </div>

          <div className="white-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">
                  Testen der digitalen Resilienz und Durchführung von
                  Stresstests
                </h3>
                <p className="col-lg-11 mx-auto">
                  DORA verpflichtet Finanzinstitute, regelmäßig
                  die Resilienz ihrer IT-Systeme zu testen und sicherzustellen,
                  dass diese auch in Krisensituationen funktionsfähig bleiben.
                  Ziel ist es, Schwachstellen zu identifizieren, die Fähigkeit
                  zur Erholung von IT-Störungen zu bewerten und die Stabilität
                  bei Cybervorfällen zu gewährleisten.
                  <br />
                  <br />
                  IT-Systeme müssen durch{" "}
                  <strong>regelmäßige Resilienztests </strong>
                  auf Bedrohungen wie Netzwerksicherheitslücken und
                  Systemstabilitätsprobleme geprüft werden. Mit diesen Tests werden
                  die Widerstandsfähigkeit der Systeme gegen Angriffe und
                  Störungen bewertet. Alle Ergebnisse und Maßnahmen müssen entsprechend dokumentiert
                  werden, um Transparenz zu gewährleisten und den
                  Aufsichtsbehörden vorgelegt werden zu können.
                  <br />
                  <br />
                  Simulierte Cyberangriffe und IT-Ausfälle als{" "}
                  <strong>Stresstests und Extremszenarien </strong> dienen dazu,
                  Belastungsgrenzen zu ermitteln und Anpassungsbedarf
                  aufzudecken. Stresstests bieten Einblicke in die Wirksamkeit
                  von Notfallplänen und zeigen Schwachstellen in den Abläufen
                  auf.
                  <br />
                  <br />
                  <strong>Externe Experten und Dokumentation:</strong> DORA
                  empfiehlt, bei Tests <strong>externe Experten </strong>{" "}
                  hinzuzuziehen, um unabhängige Bewertungen zu erhalten. Diese
                  bringen neue Perspektiven ein und erhöhen die Objektivität.
                  Testergebnisse und Schwachstellen müssen{" "}
                  <strong>umfassend dokumentiert </strong> und regelmäßig den
                  zuständigen Behörden gemeldet werden.
                  <br />
                  <br />
                  Die Erkenntnisse aus den Tests fließen in die Anpassung von
                  Notfallplänen und Sicherheitsmaßnahmen ein, um die
                  Organisation auf neue Bedrohungen vorzubereiten. So wird die
                  digitale Resilienz{" "}
                  <strong> kontinuierlich verbessert </strong> und den aktuellen
                  Standards angepasst.
                </p>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  2025 müssen laut DORA alle wesentlichen Finanzinstitute
                  mindestens einmal jährlich Stresstests durchführen, um ihre
                  Widerstandsfähigkeit gegen Cyberangriffe zu prüfen.
                </p>
              </div>
            </div>
          </div>

          <div className="gelb-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">
                  Meldepflichten und Zusammenarbeit mit Aufsichtsbehörden
                </h3>
                <p className="col-lg-11 mx-auto">
                  DORA formuliert strikte Anforderungen an die
                  Meldepflichten und Zusammenarbeit mit Aufsichtsbehörden, um im
                  Falle von IT-Störungen oder Cyberangriffen schnelle und
                  transparente Reaktionen sicherzustellen. Diese Vorgaben
                  ermöglichen es den Behörden, die Sicherheitslage im
                  Finanzsektor zu überwachen und bei Bedarf koordinierte
                  Maßnahmen einzuleiten.
                  <br />
                  <br />
                  <strong>Meldepflicht und Fristen: </strong> Finanzinstitute
                  müssen sicherheitsrelevante Vorfälle wie Cyberangriffe oder
                  Systemausfälle unverzüglich melden, in der Regel innerhalb von
                  24 Stunden nach ihrer Entdeckung. Die strikten Fristen sorgen
                  dafür, dass Behörden frühzeitig informiert sind und Risiken
                  rechtzeitig erkannt und adressiert werden können.
                  <br />
                  <br />
                  <strong>Inhalte der Meldung:</strong> Jede Meldung muss
                  detaillierte Informationen zum Vorfall enthalten, darunter die
                  Art des Vorfalls, betroffene Systeme, potenzielle Auswirkungen
                  und eingeleitete Gegenmaßnahmen. Während der
                  Vorfallbearbeitung sind regelmäßige Updates an die Behörden
                  erforderlich, um Transparenz und eine effektive
                  Vorfallbewältigung sicherzustellen.
                  <br />
                  <br />
                  <strong>Zusammenarbeit mit Behörden:</strong> Die Behörden
                  bieten im Krisenfall Unterstützung, geben Empfehlungen zur
                  Schadensbegrenzung und fördern den Informationsaustausch
                  zwischen Organisationen. Diese Zusammenarbeit trägt dazu bei,
                  Bedrohungen besser zu analysieren und den Finanzsektor auf
                  ähnliche Risiken vorzubereiten.
                  <br />
                  <br />
                  <strong>Regelmäßige Berichterstattung:</strong> Unabhängig von
                  Vorfällen müssen Finanzinstitute regelmäßig Berichte über ihre
                  Sicherheitsmaßnahmen und Resilienzstrategien einreichen. Diese
                  Berichte helfen den Behörden, den Sicherheitsstatus der
                  Institute zu bewerten, um bei Bedarf zusätzliche Maßnahmen
                  oder Audits anordnen zu können.                 </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pt-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />

            <h3 className="p-5">
              {" "}
              Unterschiede zwischen DORA und US Cybersecurity Requirements
            </h3>
            <p className="p-5 col-lg-11 mx-auto">
              Die EU-Verordnung DORA (Digital Operational Resilience Act) und
              die US Cybersecurity Requirements, wie sie z. B. durch die
              Cybersecurity and Infrastructure Security Agency (CISA) oder das
              Federal Financial Institutions Examination Council (FFIEC)
              formuliert werden, verfolgen beide das Ziel, die Cybersecurity und
              Resilienz im Finanzsektor zu verbessern. Dennoch unterscheiden sie
              sich in mehreren wichtigen Aspekten:
            </p>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Aspekt</th>
                  <th>DORA (EU)</th>
                  <th>US Cybersecurity Requirements</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Geltungsbereich</th>
                  <td>
                    - Fokus auf den Finanzsektor
                    <br />
                    - Umfasst Banken, Versicherungen, Zahlungsdienstleister und
                    Drittanbieter
                    <br />- Einheitliche Vorgaben für alle EU-Mitgliedstaaten
                  </td>
                  <td>
                    - Verschiedene Regelungen durch mehrere Behörden (z. B. SEC,
                    OCC, FFIEC)
                    <br />
                    - Fokus auf kritische Infrastrukturen und nationale
                    Sicherheit
                    <br />- Anforderungen variieren zwischen Bundesstaaten
                  </td>
                </tr>
                <tr>
                  <th>Meldepflichten</th>
                  <td>
                    - Vorfälle müssen innerhalb von 24 Stunden gemeldet werden
                    <br />- Schnelle Reaktion und Koordination auf EU-Ebene
                  </td>
                  <td>
                    - Fristen variieren (z. B. 72 Stunden in New York)
                    <br />- Keine einheitlichen Vorgaben für alle Behörden
                  </td>
                </tr>
                <tr>
                  <th>Einheitlichkeit</th>
                  <td>
                    - Harmonisierte Regelungen für alle Mitgliedstaaten
                    <br />- Einheitliche Standards für grenzüberschreitende
                    Zusammenarbeit
                  </td>
                  <td>
                    - Fragmentierte Regelungen zwischen Bundes- und Staatsebene
                    <br />- Unterschiedliche Anforderungen je nach zuständiger
                    Behörde
                  </td>
                </tr>
                <tr>
                  <th>Drittanbieter</th>
                  <td>
                    - Drittanbieter müssen DORA-Anforderungen einhalten
                    <br />- Strikte Überwachung und Sicherheitsstandards für
                    Lieferketten
                  </td>
                  <td>
                    - Verantwortung liegt oft bei beauftragenden Unternehmen
                    <br />- Weniger spezifische Vorgaben für Drittanbieter
                  </td>
                </tr>
                <tr>
                  <th>Umsetzung und Kontrolle</th>
                  <td>
                    - Hohe Anforderungen an Dokumentation und Audits
                    <br />- EU-weites Netzwerk von Aufsichtsbehörden überwacht
                    Einhaltung
                  </td>
                  <td>
                    - Unterschiedliche Handhabung je nach Behörde
                    <br />- Mehr Freiheit bei der Umsetzung, solange
                    grundlegende Anforderungen erfüllt werden
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter8_3;
